import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import styles from './style.module.scss';

const Step = (props) => {
	const direction = props.direction;

	return (
		<div className={cx({
			[styles.container]: true,
			[styles.left]: direction === 'left' ? true:false,
			[styles.right]: direction === 'right' ? true:false,
		})}>
			<div className={cx({
				[styles.inner]: true,
				[styles.left]: direction === 'left' ? true:false,
				[styles.right]: direction === 'right' ? true:false,
			})}>
				<img src={props.image}/>
				<div className={styles.content}>
					<h2>{props.title}</h2>
					{props.content.map(item => <li key={item}>{item}</li>)}
				</div>
			</div>
		</div>
	)
}

Step.propTypes = {
	title: PropTypes.string.isRequired,
	content: PropTypes.array.isRequired,
	image: PropTypes.string.isRequired,
	direction: PropTypes.string.isRequired,
}

export default Step;